import React, { useEffect, useState } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const ScrollTopButton = () => {
  const [visible, setVisible] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 576); // Bootstrap "sm"

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 576);
    };

    const toggleVisibility = () => {
      if (window.scrollY > 300 && !isSmallScreen) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [isSmallScreen]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const buttonStyle = {
    position: 'fixed',
    bottom: '90px', // Placed above the WhatsApp button (assuming it's ~60px tall with spacing)
    right: '25px',
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    backgroundColor: 'white',
    color: '#00b8f1',
    border: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 900,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };

  const hoverStyle = {
    backgroundColor: '#00b8f1',
    color: 'white',
  };

  return (
    <>
      {visible && !isSmallScreen && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={buttonStyle}
          onMouseEnter={(e) => Object.assign(e.currentTarget.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.currentTarget.style, buttonStyle)}
        >
          <FaArrowUp />
        </button>
      )}
    </>
  );
};

export default ScrollTopButton;
